import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable, map } from "rxjs";
import { array, create } from "superstruct";
import { singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import UploadedFileEntity from "./entitites/UploadedFileEntity";
import UploadedFileSchema from "./schemas/UploadedFileSchema";

@singleton()
export default class FileUploaderService {
    constructor(
        private readonly apiClient: ApiClientInterface,
        private readonly logger: LoggerInterface
    ) {}

    upload(files: File[], appName: string): Observable<UploadedFileEntity[]> {
        this.logger.debug("FileUploaderService.upload", {
            appName,
            files,
        });
        const data = new FormData();
        data.append("app", appName);

        files.forEach((file) => {
            data.append("files", file);
        });

        return this.apiClient
            .post({
                url: "/file-uploader/upload-files",
                body: data,
            })
            .pipe(
                map((response) => {
                    return create(response.body, array(UploadedFileSchema));
                })
            );
    }
}
